import {getUrl} from "../functions";
import _ from "lodash";
import {MARKET} from "../config";

export default class EditorUpload {
    constructor(loader) {
        this.loader = loader;
    }

    upload() {
        return this.loader.file.then(file => {
            const data = new FormData();
            data.append('file', file);

            const params = new URLSearchParams({
                token: !_.isUndefined(global.token) ? global.token : '',
                source: 'frontend',
                version: 2,
                market_type: MARKET,
            });

            return fetch(`${getUrl()}/templates/uploadFile?${params.toString()}`, {
                method: 'POST',
                body: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': !_.isUndefined(global.token) ? global.token : '',
                }
            })
                .then(response => response.json())
                .then(result => {
                    if (_.has(result, 'data') && _.has(result.data, 'url')) {
                        return {
                            default: result.data.url
                        };
                    }
                });
        });
    }

    abort() {
    }
}
